<div class="container mt-5" style="max-width:400px;">
  <h4>Establecer nueva contraseña</h4>

  <form [formGroup]="form" (ngSubmit)="onSubmit()">

    <div class="form-group">
      <label for="password">Nueva contraseña</label>
      <div class="input-group">
        <input id="password" [type]="passwordFieldType" formControlName="password" class="form-control">
        <div class="input-group-append">
          <span class="input-group-text" (click)="togglePassword('password')" style="cursor:pointer;">
            <i class="bx"
              [ngClass]="{'bx-show': passwordFieldType === 'password', 'bx-hide': passwordFieldType === 'text'}"></i>
          </span>
        </div>
      </div>

      <div *ngIf="submitted && form.get('password') && form.get('password')?.errors">
        <small *ngIf="form.get('password')?.errors?.['required']" class="text-danger small">La contraseña es
          requerida.</small>
        <small *ngIf="form.get('password')?.errors?.['minlength']" class="text-danger small">Mínimo 8
          caracteres.</small>
      </div>
    </div>

    <div class="form-group">
      <label for="confirmPassword">Confirmar nueva contraseña</label>
      <div class="input-group">
        <input id="confirmPassword" [type]="confirmPasswordFieldType" formControlName="confirmPassword"
          class="form-control">
        <div class="input-group-append">
          <span class="input-group-text" (click)="togglePassword('confirm')" style="cursor:pointer;">
            <i class="bx"
              [ngClass]="{'bx-show': confirmPasswordFieldType === 'password', 'bx-hide': confirmPasswordFieldType === 'text'}"></i>
          </span>
        </div>
      </div>
      <div *ngIf="submitted && form.errors?.['mismatch']" class="text-danger small">
        <small>Las contraseñas no coinciden.</small>
      </div>
    </div>

    <button type="submit" class="btn btn-primary btn-block">
      Actualizar contraseña
    </button>
  </form>

</div>